export default "__VITE_ASSET__CWLcMThD__"